var React = require('react');

function Crop (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#4F4F4F","fillRule":"evenodd"},[React.createElement("path",{"d":"M1.9 11.988c.009-.008-.234 4.817 2.596 7.748 2.83 2.93 7.675 2.842 7.652 2.864-.022.023.235-4.817-2.595-7.747-2.83-2.93-7.661-2.857-7.653-2.865z","key":0}),React.createElement("path",{"d":"M22.02 11.991c-.008-.008.234 4.817-2.596 7.748-2.83 2.93-7.675 2.842-7.652 2.864.023.022-.234-4.817 2.596-7.747 2.83-2.93 7.66-2.857 7.652-2.865zM11.951 16.133c.012 0-3.515-3.303-3.515-7.377 0-4.073 3.547-7.376 3.515-7.376-.032 0 3.515 3.303 3.515 7.376 0 4.074-3.527 7.377-3.515 7.377z","key":1})]));
}

Crop.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Crop;

Crop.default = Crop;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/common/svg/icons/crop.svg
// module id = 1470
// module chunks = 0